<template>
  <div style="padding-bottom:20px;">
    <div class="linePart">
      <el-carousel height="370px" indicator-position="none" class="carousel" v-if="line1DataLeft.length>0">
        <el-carousel-item v-for="(item,index) in line1DataLeft[0].list"  :key="item.index" class="carouselItem" >
          <div @click="judgmentTurn(item)">
            <div class="carouselImg">
              <img :src="item.url"></img>
            </div>
            <h3 class="carouselTitle">{{item.title}}</h3>
          </div>
        </el-carousel-item>
      </el-carousel>
      <card-item :limit="9" :Data="line1DataRight" v-if="line1DataRight.length>1"></card-item>
    </div>
    <div class="linePart"  v-if="lineImg.length>0">
      <img class="carecImg" :src="item.url" v-for="(item,index) in  lineImg[0].list" :key="index"></img>
    </div>
    <div class="linePart">
      <card-item :limit="7" :Data="line2DataLeft"  v-if="line2DataLeft.length>1"></card-item>
      <card-item :limit="7" :Data="line2DataRight"  v-if="line2DataRight.length>1"></card-item>
    </div>
    <div class="linePart">
      <new-list :Data="line3Data" ></new-list>
    </div>
    <div class="linePart">
      <card-item :limit="5" :Data="line4DataLeft"   v-if="line4DataLeft.length>1"></card-item>
      <card-item :limit="5" :Data="line4DataRight"  v-if="line4DataRight.length>1"></card-item>
    </div>
    <div class="linePart">
      <card-item :limit="7" cardType="download" :Data="unitDownData" v-if="unitDownData.length>1"></card-item>
      <card-item cardType="magazine" :Data="magazineData"  v-if="magazineData.length>0"></card-item>
    </div>
  </div>
</template>

<script>
import { selArticleByType } from "@/api/main";
import cardItem from '../Info/cardItem.vue'
import newList from '../Info/newList.vue'
export default {
  name: "Logged",
  components:{
    cardItem,
    newList
  },
  data() {
    return {
      Info1: {
        type: 4, // 新闻类型1，2，3
        pageNumber: 1, // 第几页
        pageSize: 5, // 每页条数
      },
      lineImg: [],
      line1DataLeft: [],
      line1DataRight: [],
      line2DataLeft: [],
      line2DataRight: [],
      line3Data: [],
      line4DataLeft: [],
      line4DataRight: [],
      unitDownData: [
        {
          title: '会员单位',
          typeId: "ff8080817e75244e017e75780be90022",
          list: ['中国中铁股份有限公司','中铁一局集团有限公司','中铁二局集团有限公司','中铁二局第二工程有限公司','中铁三局集团有限公司','中铁四局集团有限公司','中铁五局（集团）有限公司','中铁五局集团机械化工程有限责任公司','中铁六局集团有限公司','中铁六局集团北京铁路建设有限公司','中铁六局集团太原铁路建设有限公司','中铁六局集团电务工程有限公司','中铁七局集团有限公司','中铁七局集团武汉工程有限公司','中铁八局集团有限公司','中铁八局集团昆明铁路建设有限公司','中铁九局集团有限公司','中铁十局集团有限公司','中铁十局集团第二工程有限公司','中铁十局集团第一工程有限公司','中铁大桥局集团有限公司','中铁大桥勘测设计院集团有限公司','中铁隧道集团有限公司','中铁隧道勘测设计院有限公司','中铁电气化局集团有限公司','中铁电气化局集团西安铁路工程有限公司','中铁电气化勘测设计研究院有限公司','中铁通信信号勘测设计)有限公司','中铁建工集团有限公司','中铁建工集团有限公司深圳分公司','中铁上海工程局集团有限公司','中铁二院工程集团有限责任公司','中铁武汉勘察设计研究院有限责任公司','中铁二院西安勘察设计研究院有限公司','中铁二院成都勘察设计研究院有限责任公司','中铁第二院昆明勘察设计研究院有限责任公司','中铁工程设计咨询集团有限公司','中铁山桥集团有限公司','中铁宝桥集团有限公司','中铁咸阳管理干部学院','中国铁建股份有限公司','中铁十一局集团有限公司','中铁十一局集团第三工程有限公司','中铁十二局集团有限公司','中国铁建大桥工程局集团有限公司','中铁建大桥工程局集团电气化工程有限公司','中铁十四局集团有限公司','中铁十五局集团有限公司','中铁十六局集团有限公司','中铁十七局集团有限公司','中铁十八局集团有限公司','中铁十九局集团有限公司','中铁二十局集团有限公司','中铁二十一局集团有限公司','中铁二十一局集团第一工程有限公司','中铁二十二局集团有限公司','中铁二十二局集团第三工程有限公司','中铁二十三局集团有限公司','中铁二十三局集团第二工程有限公司','中铁二十四局集团有限公司','中铁二十四局集团南昌铁路工程有限公司','中铁二十五局集团有限公司','中铁二十五局集团第四工程有限公司','中国铁建电气化局集团有限公司','中铁建设集团有限公司','中国土木工程集团有限公司','中铁第一勘察设计院集团有限公司','新疆铁道勘察设计院有限公司','兰州铁道设计院有限公司','中铁第四勘察设计院集团有限公司','中铁四院集团广州设计院有限公司','中铁四院集团南宁勘察设计院有限公司','中铁第五勘察设计院集团有限公司','中铁上海设计院集团有限公司','南昌铁路勘测设计院','合肥铁路勘察设计院有限责任公司','中国铁路通信信号股份有限公司','北京全路通信信号研究设计院有限公司','哈尔滨铁路局','沈阳铁路局','北京铁路局','太原铁路局','呼和浩特铁路局','郑州铁路局','河南省铁道工程建设协会','武汉铁路局','西安铁路局','济南铁路局','上海铁路局','南昌铁路局','广州铁路(集团)公司','南宁铁路局','成都铁路局','昆明铁路局','兰州铁路局','乌鲁木齐铁路局','青藏铁路公司','京沪高速铁路股份有限公司','武广铁路客运专线有限责任公司','哈大铁路客运专线有限责任公司','津秦铁路客运专线有限公司','沪昆铁路客运专线江西有限责任公司','黔张常铁路有限责任公司','京沈铁路客运专线辽宁有限责任公司','太中银铁路有限责任公司','兰渝铁路有限责任公司','沪昆铁路客运专线贵州有限公司','东南沿海铁路福建有限责任公司','利用外资和引进技术中心','工程管理中心','铁道部党校','中国铁道科学研究院','中国铁路经济规划研究院','中国铁路经济规划研究院','中国铁路建设投资公司','铁道部直属房产建筑处','铁道第三勘察设计院集团有限公司','锦州铁道勘察设计院有限公司','沈阳铁道勘察设计院有限公司','吉林铁道勘察设计院有限公司','内蒙古铁道勘察设计院有限公司','中国建筑股份有限公司','中建铁路建设有限公司','中国交通建设集团有限公司','中交第一公路工程局有限公司','中交一航局第三工程有限公司','中交第二航务工程局有限公司','中交第四航务工程局有限公司','中国安能建设总公司','山东省公路建设(集团)有限公司','四川公路桥梁建设集团有限公司','河北路桥集团有限公司','龙建路桥股份有限公司','中国水利水电第四工程局有限公司','中国水利水电第八工程局有限公司','中煤矿建集团有限责任公司','新疆生产建设兵团建设工程(集团)有限责任公司','朔黄铁路发展有限责任公司','成都铁路工程总承包有限责任公司','中铁隆工程集团有限公司','北京久世兴建安装饰设计有限公司','中联重科股份有限公司','北京交通大学','兰州交通大学','同济大学','中南大学','西南交通大学','石家庄铁道大学','国家铁路局','中交隧道工程局有限公司','中铁城建集团有限公司','中国中铁航空港建设集团有限公司','中国铁建港航局集团有限公司','中国电建集团铁路建设有限公司','蒙西华中铁路股份有限公司','中铁第六勘察设计院集团有限公司','辽宁三三工业有限公司']
        }
      ],
      magazineData:[],
      data1: [],
      data2: [],
      data3: [],
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    toDetail(item){
      var routeData =  this.$router.resolve({
        path: `/Content`,
        query: {
          type:this.line1DataLeft[0].title,
          typeId:this.line1DataLeft[0].typeId,
          articleId: item.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    downloadView(item){
      window.open(item.url)
    },
    judgmentTurn(item){
      if(item.imageUrl){
        this.downloadView(item)
      } else {
        this.toDetail(item)
      }
    },
    getdata() {
      var that = this
      var data = {
        page:0
      }

      var line1DataRight = {...data,typeId: 'ff8080817e75244e017e756750700009',size:9}
      selArticleByType(line1DataRight).then((resp) => {
        var info = {
          title:'协会工作',
          typeId: 'ff8080817e75244e017e756750700009',
          list: resp.data.content
        }
        this.line1DataRight.push(info)
      })
      setTimeout(function(){
        var line1DataRight2 = {...data,typeId: '2c9151b4850e8bf5018f7b245a7701a2',size:9}
        selArticleByType(line1DataRight2).then((resp) => {
          var info = {
            title:'学习专栏',
            typeId: '2c9151b4850e8bf5018f7b245a7701a2',
            list: resp.data.content
          }
          that.line1DataRight.push(info)
        })
      },100)

      var line2DataLeft1 = {...data,typeId: 'ff8080817e75244e017e757797b00020',size:7}
      selArticleByType(line2DataLeft1).then((resp) => {
        var info = {
          title:'行业动态',
          typeId: 'ff8080817e75244e017e757797b00020',
          list: resp.data.content
        }
        this.line2DataLeft.push(info)
        
      })
      setTimeout(function(){
        var line2DataLeft2 = {...data,typeId: 'ff8080817e7ba2ae017e7bcbdd5a0002',size:7}
        selArticleByType(line2DataLeft2).then((resp) => {
          var info = {
            title:'重点工程',
            typeId: 'ff8080817e7ba2ae017e7bcbdd5a0002',
            list: resp.data.content
          }
          that.line2DataLeft.push(info)
        })
      },100)
      
      var line2DataRight = {...data,typeId: 'ff8080817e75244e017e756c3176000c',size:7}
      selArticleByType(line2DataRight).then((resp) => {
        var info = {
          title:'政策法规',
          typeId: 'ff8080817e75244e017e756c3176000c',
          list: resp.data.content
        }
        this.line2DataRight.push(info)
      })
      setTimeout(function(){
        var line2DataRight2 = {...data,typeId: 'ff8080817e7ba2ae017e7be7e6a9000b',size:7}
        selArticleByType(line2DataRight2).then((resp) => {
          var info = {
            title:'工法标准',
            typeId: 'ff8080817e7ba2ae017e7be7e6a9000b',
            list: resp.data.content
          }
          that.line2DataRight.push(info)
        })
      },100)
      var line1DataLeft = {...data,typeId: 'ff8080817e7ba2ae017e7fd116dc0024',size:5}
      selArticleByType(line1DataLeft).then((resp) => {
        var info = {
          title:'首页',
          typeId: 'ff8080817e7ba2ae017e7fca886b0023',
          list: resp.data.content
        }
        this.line1DataLeft.push(info)
      })
      
      var line3Data = {...data,typeId: '2c9151b4850e8bf5018f7b5713a901a4',size:5}
      selArticleByType(line3Data).then((resp) => {
        var info = {
          title:'首页',
          typeId: 'ff8080817e7ba2ae017e7fca886b0023',
          list: resp.data.content
        }
        this.line3Data.push(info)
      })
      var lineImg = {...data,typeId: '4028b8817f297703017f299018960009',size:2}
      selArticleByType(lineImg).then((resp) => {
        var info = {
          title:'首页图片',
          typeId: '4028b8817f297703017f299018960009',
          list: resp.data.content
        }
        this.lineImg.push(info)
      })

      var line4DataLeft2 = {...data,typeId: 'ff8080817e7ba2ae017e7c12714f0015',size:5}
      selArticleByType(line4DataLeft2).then((resp) => {
        var info = {
          title:'企业管理',
          typeId: 'ff8080817e7ba2ae017e7c12714f0015',
          list: resp.data.content
        }
        that.line4DataLeft.push(info)
      })
      setTimeout(function(){
        var line4DataLeft1 = {...data,typeId: 'ff8080817e75244e017e756f0e670012',size:5}
        selArticleByType(line4DataLeft1).then((resp) => {
          var info = {
            title:'评优评奖',
            typeId: 'ff8080817e75244e017e756f0e670012',
            list: resp.data.content
          }
          that.line4DataLeft.push(info)
        })
      },300)     

      var line4DataRight2 = {...data,typeId: 'ff8080817e75244e017e757847f00023',size:5}
      selArticleByType(line4DataRight2).then((resp) => {
        var info = {
          title:'企业文化',
          typeId: 'ff8080817e75244e017e757847f00023',
          list: resp.data.content
        }
        that.line4DataRight.push(info)
      })
      setTimeout(function(){
        var line4DataRight1 = {...data,typeId: 'ff8080817e7ba2ae017e7f81820d001c',size:5}
        selArticleByType(line4DataRight1).then((resp) => {
          var info = {
            title:'领军人物',
            typeId: 'ff8080817e7ba2ae017e7f81820d001c',
            list: resp.data.content
          }
          that.line4DataRight.push(info)
        })
      },100)


      var unitDownData = {...data,typeId: 'ff8080817e7ba2ae017e7fd14d700025',size:7}
      selArticleByType(unitDownData).then((resp) => {
        var info = {
          title:'文件下载',
          typeId: 'ff8080817e7ba2ae017e7fca886b0023',
          list: resp.data.content
        }
        this.unitDownData.push(info)
      })
      var magazineData = {...data,typeId: 'ff8080817e7ba2ae017e80c8182b0033',size:2}
      selArticleByType(magazineData).then((resp) => {
        var info = {
          title:'电子杂志',
          typeId: 'ff8080817e7ba2ae017e7fca886b0023',
          list: resp.data.content
        }
        this.magazineData.push(info)
      })
    },
    insurance(id, title) {
      this.$router.push({
        path: "/Info",
        query: {
          type: title,
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.linePart {
  display: flex;
  width: 100%;
  
  margin-top: 20px;
  /* padding-bottom: 20px; */
  justify-content: space-between;
}
.carousel{
  width: 590px;
  /* background: skyblue; */
}
.carousel h3{
  width: 100%;
  height: 100%;
  background: #fff;
}
.carousel .carouselItem{
  width: 100%;
  height: 100%;
  position: absolute;
}
.carousel .carouselItem .carouselImg{
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: skyblue;
}

.carousel .carouselItem .carouselImg img{
  position: relative;
  z-index: 100;
  width: 100%;
  height: 370px;
}

.carousel .carouselItem .carouselTitle{
  position: relative;
  height: 40px;
  line-height: 40px;
  left: -1px;
  right: 0;
  bottom: 41px;
  z-index: 101;
  font-size: 14px;
  padding: 0 15px;
  color: rgb(204, 204, 204);
  background: rgba(0,0,0, 0.6);
}
.carecImg{
  width: 590px;
  height: 80px;
  background: skyblue;
}
</style>
